<template>
    <UForm :schema="schema" :state="state" @submit="onSubmit">
        <div class="flex bg-white rounded gap-2 mt-2 relative">
            <UFormGroup class="w-full" name="contact" :ui="{ error: 'mt-0 absolute top-full right-0' }">
                <UInput
                    size="lg"
                    variant="none"
                    v-model="state.contact"
                    class="w-full"
                    placeholder="ایمیل یا شماره موبایل"
                />
            </UFormGroup>
            <UDivider
                class="p-1 pl-0"
                orientation="vertical"
                :ui="{
                    border: {
                        base: 'border-2 border-amazon-500 dark:border-amazon-500 rounded-full',
                    },
                }"
            />
            <UButton type="submit" :loading="loading" variant="ghost">ارسال</UButton>
        </div>
    </UForm>
</template>

<script lang="ts" setup>
import type { IDynamicKey } from "~/libs/types/general";
import { object, string, type InferType } from "yup";
import type { FormSubmitEvent } from "#ui/types";

const toast = useToast();
const loading = ref(false);

const state: IDynamicKey<string | undefined> = reactive({
    contact: undefined,
});

function checkEmailOrPhone(input: string) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let data: IDynamicKey<string | undefined> = {
        email: undefined,
        phone: undefined,
    };

    if (input && input.startsWith("09") && input.length === 11) data.phone = input;
    if (input && emailRegex.test(input)) data.email = input;

    if ((isUndefined(data.email), isUndefined(data.phone))) {
        toast.add({
            title: "خطا در ثبت اطلاعات",
            description: "فرمت ایمیل یا شماره موبایل وارد شده صحیح نیست",
            icon: "i-solar-danger-triangle-line-duotone",
            timeout: 5000,
            color: "rose",
        });
        return;
    }

    return data;
}

const schema = object({
    contact: string().required("وارد کردن این فیلد الزامی‌ست"),
});

type Schema = InferType<typeof schema>;

async function handleRegister(data: IDynamicKey<string | undefined>) {
    loading.value = true;
    await fetchData("/subscribe", {
        method: "POST",
        useSanctum: true,
        body: data,
        onResponse({ response }) {
            if (response.ok) {
                toast.add({
                    title: "ذخیره موفق",
                    description: "اطلاعات شما با موفقیت ذخیره شد.",
                    icon: "i-solar-check-circle-line-duotone",
                    timeout: 5000,
                    color: "green",
                });
            }
        },
        onResponseError({ response }) {
            if (response.status === 422) {
                toast.add({
                    title: "مخاطب تکراری",
                    description: "مخاطب وارد شده در لیست خبرنامه موجود است",
                    icon: "i-solar-check-circle-line-duotone",
                    timeout: 5000,
                    color: "yellow",
                });
            } else if (response.status === 429) {
                toast.add({
                    title: "خطا در ارسال",
                    description: "تعداد درخواست‌های شما بیش از حد مجاز بود، لطفا چند دقیقه دیگر مجدد تلاش کنید.",
                    icon: "i-solar-check-circle-line-duotone",
                    timeout: 5000,
                    color: "yellow",
                });
            }
        },
    }).finally(() => {
        loading.value = false;
    });
}

function onSubmit(event: FormSubmitEvent<Schema>) {
    if (event.data) {
        const data = checkEmailOrPhone(event.data.contact);
        if (data) handleRegister(data);
    }
}
</script>

<style></style>
